<template>

  <div class="page">
		<div class="gridheader">
			<div class="row">
				<div class="col-12 title">
					<h1 class="mrgn">{{ $t('CONTROLPANEL')}}</h1>
					<ul class="list-unstyled">
						<li><router-link to="/controlpanel/basic">{{ $t('BASICDATA')}}</router-link></li>
						<li class="active"><router-link to="/controlpanel/connection">{{ $t('CONNECTINGTOOTHERCOMPANIES')}}</router-link></li>
					</ul>
				</div>
			</div>
		</div>
    <div class="grid-white-search">
      <div class="row">
        <div class="col-md-8 col">
          <autocomplete v-bind:setvalue="setCompanyId" v-bind:value="companyId" v-bind:placeholder="$t('COMPANY')" v-bind:values="getCompaniesOptions" v-bind:initdata="getCompanies"></autocomplete>
        </div>
        <div class="col-md-4 col text-right">
          <a href="#" v-on:click.prevent="addPartner" class="btn btn-green"><img src="../assets/img/user-plus-green.svg" alt=""> {{$t('ADDPARTNER')}}</a>
        </div>
      </div>
    </div>
    <div class="lower-page">
      <div class="row" v-if="waitingpartners.totalCount > 0">
        <div class="col-12">
          <h3>{{$t('WAITINGCONNECTIONS')}}</h3>
        </div>
        <div class="col-12">
          <div class="row lower-item" v-for="company in waitingpartners.root">
            <div class="col-md-8 company">
              {{company.companyName}}
            </div>
            <div class="col-md-4 text-right">
              <a href="#" v-on:click.prevent="declinePartner(company.companyId)" class="btn btn-red">{{$t('DECLINE')}}</a>
              <a href="#" v-on:click.prevent="acceptPartner(company.companyId)" class="btn btn-green">{{$t('ACCEPT')}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="pendingPartners.totalCount > 0">
        <div class="col-12">
          <h3>{{$t('PENDINGCONNECTIONS')}}</h3>
        </div>
        <div class="col-12">
          <div class="row lower-item" v-for="company in pendingPartners.root">
            <div class="col-12 company">
              {{company.companyName}}
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="connectedPartners.totalCount > 0">
        <div class="col-12">
          <h3>{{$t('CONNECTEDPARTNERS')}}</h3>
        </div>
        <div class="col-12">
          <div class="row lower-item" v-for="company in connectedPartners.root">
            <div class="col-md-8 company">
              {{company.companyName}}
            </div>
            <div class="col-md-4 text-right">
              <a href="#" v-on:click.prevent="deletePartnership(company.companyId)" class="btn btn-red">{{$t('DISCONNECT')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import partnerApi from '@/api/partners'
import companyApi from '@/api/companydata'

export default {
  name: 'ControlPanel',
  data: function()
  {
    return {
      companyId: '',
      companies: {
        root: [],
        totalCount: 0
      },
      connectedPartners: {
        root: [],
        totalCount: 0
      },
      waitingpartners: {
        root: [],
        totalCount: 0
      },
      pendingPartners: {
        root: [],
        totalCount: 0
      }
    };
  },
  created: function()
  {
    var me = this;
    me.getPartners();
  },
  methods:
  {
    getPartners()
    {
      var me = this;
      me.getWaitingPartners();
      me.getPendingPartners();
      me.getConnectedPartners();
    },
    setCompanyId(val)
    {
      var me = this;
      me.companyId = val;
    },
    getConnectedPartners: function()
    {
      var me = this;
      partnerApi.getPartners({connected: 1}, function(data)
      {
        me.connectedPartners = data;
      });
    },
    getWaitingPartners: function()
    {
      var me = this;
      partnerApi.getPartners({connected: 0}, function(data)
      {
        me.waitingpartners = data;
      });
    },
    getPendingPartners: function()
    {
      var me = this;
      partnerApi.getPartners({pending: 1}, function(data)
      {
        me.pendingPartners = data;
      });
    },
    getCompanies: function(params)
    {
      var me = this;
      companyApi.selectRow(params, function(data)
      {
        if(data.error)
        {
          me.$notify.error(data.notice);
        }
        else
        {
          me.companies = data;
        }
      });
    },
    addPartner: function()
    {
      var me = this;
      partnerApi.addPartner({companyId: me.companyId}, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        me.$notify.info(val.notice);
        me.getPartners();
      });
    },
    deletePartnership: function(companyId)
    {
      var me = this;
      partnerApi.deletePartnership({companyId: companyId}, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    },
    declinePartner: function(companyId)
    {
      var me = this;
      partnerApi.declinePartner({companyId: companyId}, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    },
    acceptPartner: function(companyId)
    {
      var me = this;
      partnerApi.acceptPartner({companyId: companyId}, function(val)
      {
        if(val.error)
        {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    }
  },
  computed:
  {
    getCompaniesOptions: function()
    {
      var me = this,
        options = [];

      for(var i=0;i<me.companies.root.length;i++)
      {
        var company = me.companies.root[i];
        options.push({value: company.companyId, text: company.companyName})
      }

      return options;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConnectionPanel.vue